/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvitationWithdrawRequestDto } from '../../models/invitation-withdraw-request-dto';

export interface WithdrawCustomerInvitation$Params {
  customerId: string;
      body: InvitationWithdrawRequestDto
}

export function withdrawCustomerInvitation(http: HttpClient, rootUrl: string, params: WithdrawCustomerInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, withdrawCustomerInvitation.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

withdrawCustomerInvitation.PATH = '/kyc/customers/{customerId}/invitation/withdraw';
